module.exports = __webpack_public_path__ + "static/media/call-auth-advantage-connect.5703ddea.png";